'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _utilsAccessibility = require('@bibliocommons/utils-accessibility');

require('../styles/Rating.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconColorMap = {
  gold: '#F4A204',
  silver: '#999',
  blue: '#02729E'
};

var iconStrokeColorMap = {
  blue: '#035D80',
  gold: '#9E5E15',
  silver: '#666'
};

var Rating = function (_BcReactComponent) {
  _inherits(Rating, _BcReactComponent);

  function Rating(props) {
    _classCallCheck(this, Rating);

    var _this = _possibleConstructorReturn(this, (Rating.__proto__ || Object.getPrototypeOf(Rating)).call(this, props));

    _this.state = {
      selectedRating: 0
    };

    _this.bindAll('updateRating', 'handleRatingButtonClick', 'handleRemoveItemRating', 'renderStars');

    _this.removeButtonRef = null;
    return _this;
  }

  _createClass(Rating, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          rating = _props.rating,
          readOnly = _props.readOnly;

      if (rating && !readOnly) {
        this.setState({
          selectedRating: rating
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If the remove button currently has focus, but it's about to be removed from the DOM,
      // then move focus to the next focusable element on the page, othwerwise focus will be lost.
      if (this.props.rating && !nextProps.rating && this.removeButtonRef && document.activeElement) {
        var button = _reactDom2.default.findDOMNode(this.removeButtonRef); // eslint-disable-line react/no-find-dom-node

        if (button.contains(document.activeElement)) {
          var nextFocusableElement = (0, _utilsAccessibility.getNextFocusableElement)(button);
          if (nextFocusableElement) {
            nextFocusableElement.focus();
          }
        }
      }
    }
  }, {
    key: 'updateRating',
    value: function updateRating(selectedRating) {
      if (this.props.isLoading) {
        return;
      }

      this.setState({ selectedRating: selectedRating });
    }
  }, {
    key: 'handleRatingButtonClick',
    value: function handleRatingButtonClick(rating) {
      var _this2 = this;

      if (this.props.isLoading) {
        return;
      }

      this.setState({ selectedRating: rating });
      this.props.handleButtonClick(rating);

      this.timeout = setTimeout(function () {
        if (!_this2.props.isLoading) {
          _this2.setState({
            selectedRating: _this2.props.rating || 0
          });
        }
        _this2.timeout = null;
      }, 100);
    }
  }, {
    key: 'handleRemoveItemRating',
    value: function handleRemoveItemRating() {
      if (this.props.isLoading) {
        return;
      }

      this.setState({ selectedRating: 0 });
      this.props.handleRemoveClick();
    }
  }, {
    key: 'renderStars',
    value: function renderStars() {
      var stars = [];
      var _props2 = this.props,
          id = _props2.id,
          readOnly = _props2.readOnly,
          variant = _props2.variant;

      var rating = this.props.rating || 0;
      var normalizedRating = void 0;

      if (readOnly) {
        // If the rating is read only, round up to the nearest star
        normalizedRating = Math.round(rating / 10) * 10;
      } else if (this.state.selectedRating > 0) {
        normalizedRating = this.state.selectedRating;
      } else {
        normalizedRating = rating;
      }

      var halfStars = normalizedRating % 20 > 0 ? 1 : 0;

      var color = normalizedRating === 0 ? iconColorMap.silver : iconColorMap[variant];
      var strokeColor = normalizedRating === 0 ? iconStrokeColorMap.silver : iconStrokeColorMap[variant];

      // Full stars
      _lodash2.default.times(Math.floor(normalizedRating / 20), function (n) {
        stars.push(_react2.default.createElement(_baseIcons.StarFull, { key: 'star-full-' + n + '-' + id, className: 'rating-star star-full', color: color, strokeColor: strokeColor }));
      });

      // Half stars
      _lodash2.default.times(halfStars, function (n) {
        stars.push(_react2.default.createElement(_baseIcons.StarHalf, { key: 'star-half-' + n + '-' + id, className: 'rating-star star-half', color: color, strokeColor: strokeColor }));
      });

      // Empty stars
      _lodash2.default.times(5 - Math.round(normalizedRating / 20), function (n) {
        stars.push(_react2.default.createElement(_baseIcons.StarEmpty, { key: 'star-empty-' + n + '-' + id, className: 'rating-star star-empty', color: color, strokeColor: strokeColor }));
      });

      return stars;
    }
  }, {
    key: 'renderButtons',
    value: function renderButtons() {
      var _this3 = this;

      var _props3 = this.props,
          id = _props3.id,
          readOnly = _props3.readOnly;


      if (readOnly) {
        return _react2.default.createElement('noop', null);
      }

      return _lodash2.default.times(10, function (n) {
        var value = (n + 1) * 10;
        var count = (n + 1) / 2;
        return _react2.default.createElement(
          _baseButtons.DefaultButton,
          {
            key: 'rating-button-' + n + '-' + id,
            className: 'rating-button',
            role: 'button',
            onMouseOver: function onMouseOver() {
              return _this3.updateRating(value);
            },
            onTouchStart: function onTouchStart() {
              return _this3.handleRatingButtonClick(value);
            },
            onFocus: function onFocus() {
              return _this3.updateRating(value);
            },
            handleClick: function handleClick() {
              return _this3.handleRatingButtonClick(value);
            } },
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ratings_count', values: { count: count } })
          )
        );
      });
    }
  }, {
    key: 'renderRemoveButton',
    value: function renderRemoveButton() {
      var _this4 = this;

      var _props4 = this.props,
          rating = _props4.rating,
          readOnly = _props4.readOnly,
          isLoading = _props4.isLoading;

      if (rating && !readOnly || isLoading) {
        return _react2.default.createElement(
          _baseButtons.IconButton,
          {
            className: 'remove-rating-button',
            isLoading: isLoading,
            handleClick: this.handleRemoveItemRating,
            ref: function ref(el) {
              _this4.removeButtonRef = el;
            } },
          _react2.default.createElement(_baseIcons.Cross, { className: 'extra-small' }),
          _react2.default.createElement(
            _baseScreenReaderMessage2.default,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'remove_rating' })
          )
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props5 = this.props,
          id = _props5.id,
          rating = _props5.rating,
          readOnly = _props5.readOnly,
          variant = _props5.variant;


      if (!rating && readOnly) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'cp-rating ' + variant, 'aria-labelledby': id },
        _react2.default.createElement(
          'span',
          { className: 'sr-only', id: id },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'screenReaderStarRating',
            values: {
              rating: rating / 20
            } })
        ),
        _react2.default.createElement(
          'div',
          { className: 'rating-star-wrap' },
          this.renderStars()
        ),
        _react2.default.createElement(
          'div',
          {
            role: 'region',
            id: 'rating-select-' + id,
            className: 'rating-star-button-wrap',
            onMouseLeave: function onMouseLeave() {
              return _this5.updateRating(0);
            },
            onBlur: function onBlur() {
              return _this5.updateRating(0);
            } },
          _react2.default.createElement(
            'div',
            { 'aria-controls': 'rating-select-' + id, 'aria-label': 'Rating stars' },
            this.renderButtons()
          )
        ),
        this.renderRemoveButton()
      );
    }
  }]);

  return Rating;
}(_baseBcReactComponent2.default);

Rating.propTypes = {
  rating: _react.PropTypes.number, // integer 0 - 100
  id: _react.PropTypes.string.isRequired,
  variant: _react.PropTypes.oneOf(['blue', 'gold', 'silver']),
  readOnly: _react.PropTypes.bool,
  handleButtonClick: _react.PropTypes.func,
  handleRemoveClick: _react.PropTypes.func,
  isLoading: _react.PropTypes.bool
};

Rating.defaultProps = {
  rating: 0,
  variant: 'gold',
  isLoading: false,
  readOnly: false
};

Rating.displayName = 'Rating';

exports.default = Rating;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/rating/lib/components/Rating.component.js
// module id = 1457
// module chunks = 1